import { render, staticRenderFns } from "./SupportIcon.vue?vue&type=template&id=2246f56a&scoped=true&"
import script from "./SupportIcon.vue?vue&type=script&lang=ts&"
export * from "./SupportIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SupportIcon.vue?vue&type=style&index=0&id=2246f56a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2246f56a",
  null
  
)

export default component.exports